/* src/app/components/menus/nav-menu/nav-menu.component.scss */
.navbar-main {
  border-radius: 0;
  border: none;
  font-size: 13.5px;
  margin-bottom: 0px;
  height: 51px;
}
.navbar-globe {
  margin-right: 13px;
  width: 100%;
  max-width: 25px !important;
  height: 100%;
  vertical-align: text-top;
  display: inline;
  background-color: transparent;
}
.navbar-brand img {
  width: unset !important;
}
.nav-item {
  color: #ffffff;
}
.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: #bcbec0;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
.navbar-toggler:focus {
  border: 0 !important;
}
.navbar-toggler-icon {
  width: 1.3em;
  height: 1.3em;
  visibility: visible !important;
}
.dropdown-item {
  display: block;
  width: 100%;
  clear: both;
  font-weight: 400;
  color: #ffffff !important;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  padding: 10px;
}
.dropdown-item:focus,
.dropdown-item:hover {
  color: #16181b;
  text-decoration: none;
  background-color: #005992;
  border: 0;
}
.arrow-down {
  position: relative;
  top: -2px;
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: 0.2em solid #ffffff;
  border-top: 0.2em solid #ffffff;
  transform: rotate(135deg);
  margin-left: 1em;
}
.dropdown-toggle::after {
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  margin-right: 0.5em;
  margin-left: 1em;
}
.navbar.navbar-default {
  padding-left: 50px;
  padding-right: 50px;
  position: relative;
  margin-top: 70px;
}
.navbar.navbar-default .navbar-text {
  color: #434343 !important;
}
.navbar-text a {
  color: #3774A9;
}
.navbar-dropdown {
  margin-top: 8px;
}
.navbar-value {
  padding-left: 10px;
  font-family: open_sansbold !important;
}
.navbar-brand {
  padding: 14px 15px 15px 15px;
  height: 51px;
}
li.navbar-text {
  color: #fafafa;
  cursor: default;
  font-size: 13px;
  margin-right: 0px;
  margin-left: 0px;
}
.navbar-text {
  margin-right: 0px;
  padding: 0px;
  font-family: "open_sansregular";
}
.navbar-gray li.navbar-text {
  color: #555;
}
.navbar-right {
  margin-left: auto;
  order: 2;
}
.navbar-secondary {
  position: absolute;
  margin-top: 25px;
  background-color: #f8f8f8;
  display: block;
  line-height: 20px;
  width: 100%;
}
.navbar-form {
  padding-left: 0px;
}
.navbar-name a {
  display: inline-block;
  max-width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-top: 15px;
}
.navbar-brand.product-name {
  padding-bottom: 17px !important;
  margin-left: 0px;
  margin-right: 0;
  font-size: 18px;
  height: 51px;
}
.navbar-inverse .navbar-nav > .dropdown > a .caret {
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
}
.nav > li {
  margin-left: 0;
}
.navbar > .container .navbar-brand {
  min-width: 140px;
}
.navbar-inverse {
  background-color: #1b70bb;
}
.navbar-nav > li > span {
  cursor: default;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #f0f0f0 !important;
  display: block;
  position: relative;
  line-height: 20px;
}
.navbar-inverse .navbar-brand,
.navbar-inverse .navbar-nav > li > a {
  color: #ffffff !important;
  background-color: inherit;
  cursor: pointer;
  line-height: 31px;
  padding: 10px 15px;
}
.navbar-inverse .navbar-brand:hover,
.navbar-inverse .navbar-nav > li > a:hover {
  background-color: #005992;
}
.navbar-inverse .navbar-brand:focus,
.navbar-inverse .navbar-nav > li > a:focus {
  background-color: #005992;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.navbar-brand.shadow-right {
  -webkit-box-shadow: 2px 0 5px -2px #000a11;
  box-shadow: 2px 0 5px -2px #011726;
}
.navbar-toggle {
  border: none;
}
.navbar-inverse .navbar-toggle:hover,
.navbar-inverse .navbar-toggle:focus {
  background-color: transparent;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.navbar-search {
  position: relative;
  top: 3px;
}
.navbar-search input {
  border: none;
  height: 28px;
  font-size: 12px;
  padding: 0px 6px;
  text-overflow: ellipsis;
}
.navbar-search .btn {
  height: 28px;
  padding: 0px 8px;
}
.navbar-search .fa-search {
  color: #ffffff;
}
.navbar-inverse .navbar-brand:hover,
.navbar-inverse .navbar-nav > li > a:hover,
.navbar-inverse .navbar-nav > li > a[aria-expanded=true] {
  background-color: #005992;
}
.dropdown-menu {
  background-color: #1b70bb !important;
  margin-top: 0;
  border-radius: 0;
  width: 193px;
}
.dropdown-menu.dropdown-menu-primary {
  background-color: #1b70bb !important;
  margin-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.dropdown-menu.dropdown-menu-primary > li > a {
  color: #1b70bb !important;
  cursor: pointer;
  color: #ffffff !important;
}
.dropdown-menu.dropdown-menu-primary > li > a:hover,
.dropdown-menu.dropdown-menu-primary > li > a:focus {
  background-color: #005992;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.nav-menu-span {
  vertical-align: middle;
}
.navbar-dropdown input {
  height: 32px;
}
.margin-right-5 {
  margin-right: 5px;
}
.hidden {
  display: none !important;
}
.router-link-active {
  background-color: #005992 !important;
}
.dropdown-menu {
  padding: 0;
  border: none;
}
.dropdown-item {
  display: block;
  width: 100%;
  clear: both;
  font-weight: 400;
  color: #ffffff !important;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  padding: 10px;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #005992;
  border: 0;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.dropdown-item.active,
.dropdown-item:active {
  color: #ffffff;
  text-decoration: none;
  background-color: #0071bb;
}
.greeting,
.greeting-li {
  font-size: 13px;
  padding-left: 16px;
  padding-right: 10px;
  color: #ffffff;
  text-decoration: none;
  cursor: default;
}
.greeting:hover,
.greeting-li:hover {
  background-color: #0071bb !important;
  cursor: default !important;
}
.greeting:focus,
.greeting-li:focus {
  background-color: #0071bb !important;
  cursor: default !important;
  border: none !important;
}
@media screen and (max-width: 960px) and (min-width: 768px) {
  .nav-item {
    font-size: x-small;
    padding: 0px;
  }
  .navbar-brand-name {
    display: none;
  }
  .nav-item-hello {
    display: none;
  }
}
@media screen and (max-width: 1024px) and (min-width: 961px) {
  .nav-item {
    font-size: small;
  }
  .navbar-brand-name {
    display: none;
  }
  .nav-item-hello {
    display: none;
  }
}
@media screen and (max-width: 1204px) and (min-width: 1025px) {
  .navbar-brand-name {
    display: none;
  }
}
/*# sourceMappingURL=nav-menu.component.css.map */
